import { getLockedDaysInTimerange } from './getLockedDaysInTimerange/getLockedDaysInTimerange'
import { getLockedDaysInWeek } from './getLockedDaysInWeek/getLockedDaysInWeek'
import { payPeriodsBaseSelectors } from './payPeriodsBaseSelectors'

export const payPeriodsSelectors = {
  ...payPeriodsBaseSelectors,
  getLockedDaysInTimerange,
  getLockedDaysInWeek
}
